import { Close } from '@mui/icons-material'
import { MODAL_CONSTS } from '../../const/modal-const'

type Props = {
  show?: boolean
  handleModal?: any
  dataToPassOn?: any
}

const RegistrationPeopleModal = (props: Props) => {
  return (
    <>
      <div
        className={`modal fade fixed z-50 w-full top-15 h-screen outline-none flex items-center justify-center overflow-x-hidden overflow-y-auto ${props.show ? 'show d-block backShadow' : 'hidden'}`}
        aria-labelledby="exampleModalCenterTitle"
        aria-modal="true"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered relative lg:w-3/5 xl:w-1/3 m-auto pointer-events-none">
          <div
            className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-2xl outline-none text-current pb-10 pt-8 px-8"
            style={{ width: 'max-content', maxWidth: '146%', height: 'fit-content' }}
          >
            <span
              onClick={() => props.handleModal(false, MODAL_CONSTS.REGISTRATION_PEOPLE)}
              className="absolute text right-2 top-2 text-SeabiscuitDark200ThemeColor cursor-pointer"
            >
              <Close className="text-[#122B46]" />
            </span>

            <div className="modal-header rounded-t-xl font-Poppins h-[100%]">
              <h5 className="text-xl leading-normal text-SeabiscuitDark200ThemeColor font-normal">
                People Information
              </h5>

              <div className="allInfo text-[#122B46]  overflow-y-auto pr-2 h-[100%]">
                <p className="mt-4 font-[Poppins]">
                This is where you add the people you will include in your registration. This includes any riders, trainers, owners, grooms, etc.
                </p>
                <p className="mt-4">
                You will be able to register these people for classes, send them paperwork to sign, and split the bill with them.
                </p>

                <p className="mt-4">
                  {' '}
                  If you do not add a team member here, <b>you will not</b> be able to select them during the rest of the registration process.
                </p>
              </div>

              {/* <button
                                onClick={() => props.handleModal(false, MODAL_CONSTS.ACCOUNT_PRIVACY)}
                                type="button"
                                className="w-full mt-6 h-12 mx-auto block items-center justify-center py-2 px-4 border border-transparent rounded-lg shadow-sm text-sm font-medium text-SeabiscuitLightTextColor bg-SeabiscuitLightThemeColor hover:text-white hover:bg-SeabiscuitMainThemeColor focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-SeabiscuitMainThemeColor">
                                CLOSE
                            </button> */}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default RegistrationPeopleModal
